// used by forms
import { Component, ContentChild, Input, signal, TemplateRef } from '@angular/core';


export interface ExpansionPanel {
  title: string;
  expanded?: boolean;
  disabled?: boolean;
  context: any;
  contentTemplate?: TemplateRef<any>;
  done: boolean;
}


@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent {
  @Input() panels: ExpansionPanel[] = [];
  @Input() multi: boolean = false; // Allow multiple panels to be open at once
  
  // For custom header templates
  @ContentChild('headerContent') headerContent: TemplateRef<any> | null = null;
  
  // For custom body templates
  @ContentChild('bodyContent') bodyContent: TemplateRef<any> | null = null;

  togglePanel(panel: ExpansionPanel): void {
    if (!this.multi) {
      // Close all other panels if not in multi mode
      this.panels.forEach(p => {
        if (p !== panel) {
          p.expanded = false;
        }
      });
    }
    panel.expanded = !panel.expanded;
  }

  // Close all panels (respecting disabled state)
  closeAllPanels(except?: ExpansionPanel): void {
    this.panels.forEach(panel => {
      if (!panel.disabled && panel !== except) {
        panel.expanded = false;
      }
    });
  }

  onPanelOpened(panel: ExpansionPanel) {
    if (!panel.disabled) {
      panel.expanded = true;
    }
  }

  onPanelClosed(panel: ExpansionPanel) {
    if (!panel.disabled) {
      panel.expanded = false;
    }
  }
}
